import * as React from 'react';
import { useState } from 'react';

import type { BannerColors, Cta, TextLayoutOptions } from '@coursera-web/cds-labs';
import { PromoBarModule } from '@coursera-web/cds-labs';

import type { MerchandisingModuleModuleType } from '@coursera/event-pulse-types';

import { useCampaignModulesData } from 'bundles/campaigns/context/CampaignModulesDataContext';

export const useShouldShowCampaignPromoBarModule = () => {
  const { campaignData, loading } = useCampaignModulesData();
  return !!campaignData?.promoBarModule?.contentDataJson || loading;
};

const CampaignPromoBarModuleRenderer = () => {
  const [isDismissed, setIsDismissed] = useState<boolean>(false);
  const handleDismiss = () => {
    setIsDismissed(true);
  };

  const moduleData = useCampaignModulesData()?.campaignData?.promoBarModule;
  const content = moduleData?.contentDataJson;

  if (!useShouldShowCampaignPromoBarModule()) {
    return null;
  }

  const {
    headline,
    description,
    textLayout,
    backgroundColor,
    bannerColor,
    centerContent,
    primaryCtaText,
    primaryCtaTarget,
    hideBackgroundImages,
  } = content || {};

  const moduleEventingData = {
    moduleType: 'promo_bar' as MerchandisingModuleModuleType,
    heading: headline ?? '',
    body: description ?? '',
    campaign: {
      id: moduleData?.campaignId ?? '',
      matchedCountryCode: moduleData?.matchedCountryCode ?? '',
      epicExperimentId: moduleData?.epicExperimentId ?? '',
      regionName: moduleData?.regionName ?? '',
      campaignName: moduleData?.campaignName ?? '',
    },
  };

  let cta: Cta;
  if (primaryCtaText && primaryCtaTarget) {
    cta = {
      text: primaryCtaText,
      href: primaryCtaTarget,
    };
  }

  const getPromoBarModuleProps = () => {
    return {
      headline: headline ?? '',
      description: description ?? '',
      textLayout: textLayout as TextLayoutOptions,
      backgroundColor: backgroundColor ?? 'white',
      centerContent: !!centerContent,
      bannerColor: bannerColor as BannerColors,
      isDismissed,
      onDismiss: handleDismiss,
      cta,
      hideBackgroundImages,
      moduleEventingData,
    };
  };

  return <PromoBarModule {...getPromoBarModuleProps()} />;
};

export default CampaignPromoBarModuleRenderer;
